<!--
 * @Author: Sephiroth·D·Kid
 * @Date: 2019-07-08 09:43:37
 * @LastEditors: Sephiroth·D·Kid
 * @LastEditTime: 2019-07-09 15:56:32
 * @Description: 专项审计报告 2018
 -->
<template>
  <div class="special-reports-2018">
    <img :src="item" alt="" srcset="" v-for="(item, index) in imgList" :key="index" />
  </div>
</template>
<script>
export default {
  name: 'special-reports-2018',
  computed: {
    imgList() {
      let arr = [];
      for (let i = 1; i < 20; i++) {
        const index = i < 10 ? `0${i}` : i;
        arr.push(
          `https://files.jinr.com/jinr-index/financial-reports/special-2018/sjbg_${index}.png`
        );
      }
      return arr;
    }
  }
};
</script>
